<template>
  <div class="box">
    <p class="content_title">发布信息</p>
    <div class="content_line"></div>
    <div>
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="100px"
               class="demo-ruleForm">
        <div class="rule_box">
          <div class="rule_left">
            <el-form-item label="标题"
                          prop="title">
              <el-input v-model="ruleForm.title"
                        placeholder="请输入兼职标题"></el-input>
            </el-form-item>
            <el-form-item label="价格"
                          prop="price">
              <el-input v-model="ruleForm.price"
                        placeholder="请输入价格"></el-input>
            </el-form-item>
            <el-form-item label="要求"
                          prop="requirement">
              <el-select v-model="ruleForm.requirement"
                         placeholder="请选择">
                <el-option label="男"
                           value="男"></el-option>
                <el-option label="女"
                           value="女"></el-option>
                <el-option label="不限"
                           value="不限"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工作地址"
                          prop="address">
              <el-input v-model="ruleForm.address"
                        placeholder="请输入工作地址"></el-input>
            </el-form-item>
            <el-form-item label="联系方式"
                          prop="phone">
              <el-input v-model="ruleForm.phone"
                        type="number"
                        maxlength="11"
                        placeholder="请输入联系方式"></el-input>
            </el-form-item>
          </div>
          <div class="rule_right">
            <el-form-item label="公司"
                          prop="company">
              <el-input v-model="ruleForm.company"
                        placeholder="请输入公司名称"></el-input>
            </el-form-item>
            <el-form-item label="类别"
                          prop="chooseType">
              <el-select v-model="ruleForm.chooseType"
                         placeholder="请选择">
                <el-option label="短期招工"
                           value="短招"></el-option>
                <el-option label="高薪日结"
                           value="高薪"></el-option>
                <el-option label="周末兼职"
                           value="周末兼职"></el-option>
                <el-option label="食宿全包"
                           value="包吃住"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工作福利"
                          prop="welfare">
              <el-checkbox-group v-model="ruleForm.welfare"
                                 @change="welfareChange">
                <el-checkbox-button v-for="item in welfareType"
                                    :label="item"
                                    :key="item.num">{{item.txt}}</el-checkbox-button>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="工作内容"
                          prop="content">
              <el-input v-model="ruleForm.content"
                        type="textarea"
                        class="content_box"
                        placeholder="请输入工作内容"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="btn"
             @click="submitForm('ruleForm')">{{btnTxt}}</div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // welfareType: ['包吃', '包住', '交通补贴', '免费培训', '有提成'],
      welfareType: [
        {
          num: 1,
          txt: '包吃'
        },
        {
          num: 2,
          txt: '包住'
        },
        {
          num: 3,
          txt: '交通补贴'
        },
        {
          num: 4,
          txt: '免费培训'
        },
        {
          num: 5,
          txt: '有提成'
        }
      ],
      ruleForm: {
        title: '',//标题
        price: '',//价格
        requirement: '',//要求
        address: '',//工作地址
        phone: '',//联系方式
        company: '',//公司
        chooseType: '',//类别
        welfare: [],//福利
        content: '',//工作内容
        btnTxt: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入兼职标题', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入价格', trigger: 'blur' }
        ],
        requirement: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        company: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        chooseType: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入正确的联系方式', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入工作地址', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入工作内容', trigger: 'blur' }
        ],
        welfare: [
          { required: true, message: '请选择工作福利', trigger: 'change' }
        ]
      },
      jobCode: '',//默认为空
      info: {},
    }
  },
  created () {
    this.jobCode = this.$route.query.jobCode;
    if (this.jobCode) {
      this.btnTxt = '编辑信息';
      this.getInfo();
    } else {
      this.btnTxt = '发布信息';
    }
  },
  methods: {
    getInfo () {//获取信息
      this.$get("/app/api/v1/verify/detail", { jobCode: this.jobCode })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.info = res.data.detail;
            let newArr = []
            if (this.info.welfare) {
              this.info.welfare.split(',').forEach(num =>
                newArr.push(this.welfareType[num - 1])
              )
            }
            console.log(newArr)
            this.ruleForm = {
              title: this.info.title,//标题
              price: this.info.salary,//价格
              requirement: this.info.sex,//要求
              address: this.info.openAddr,//工作地址
              phone: this.info.phone,//联系方式
              company: this.info.companyName,//公司
              chooseType: this.info.tag,//类别
              welfare: newArr,//福利
              content: this.info.jobDesc,//工作内容
            }
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        })
        .catch((err) => { });
    },
    welfareChange () {//选择工作福利
      // console.log(this.ruleForm.welfare)
      let welfaerArr = [];
      this.ruleForm.welfare.forEach((item) => {
        welfaerArr.push(item.num)
      })
      console.log(welfaerArr)
      console.log(this.ruleForm.welfare)
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let welfaerArr = [];
          if (this.ruleForm.welfare.length > 0) {
            console.log(this.ruleForm.welfare.length)
            this.ruleForm.welfare.forEach((item) => {
              welfaerArr.push(item.num)
            })
          }
          let param = {
            title: this.ruleForm.title,
            companyName: this.ruleForm.company,
            salary: this.ruleForm.price,
            tag: this.ruleForm.chooseType,
            sex: this.ruleForm.requirement,
            welfare: welfaerArr.toString(),
            openAddr: this.ruleForm.address,
            jobDesc: this.ruleForm.content,
            phone: this.ruleForm.phone,
            id: this.jobCode
          }
          if (this.jobCode) {//编辑
            this.$post("/app/api/v1/verify/edit/job", param)
              .then((res) => {
                console.log(res)
                if (res.code == 200) {
                  this.$message({
                    message: '编辑成功',
                    type: 'success'
                  });
                } else {
                  this.$message({
                    message: res.msg,
                    type: 'warning'
                  });
                }
              })
              .catch((error) => { });
          } else {//添加
            this.$post("/app/api/v1/verify/add/job", param)
              .then((res) => {
                console.log(res)
                if (res.code == 200) {
                  this.$message({
                    message: '发布成功',
                    type: 'success'
                  });
                  this.$router.push({
                    path: "/perCenter",
                  });
                  // this.ruleForm = {
                  //   title: '',//标题
                  //   price: '',//价格
                  //   requirement: '',//要求
                  //   address: '',//工作地址
                  //   phone: '',//联系方式
                  //   company: '',//公司
                  //   chooseType: '',//类别
                  //   welfare: [],//福利
                  //   content: '',//工作内容
                  // }
                } else {
                  this.$message({
                    message: res.msg,
                    type: 'warning'
                  });
                }
              })
              .catch((error) => { });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
}
</script>

<style scoped>
.box {
  margin-top: 10px;
  width: 100%;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #f5f5f5;
}
.content_title {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  padding-left: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f2f2f2;
}
.content_line {
  width: 104px;
  height: 2px;
  background: #e53631;
  margin-top: -2px;
  margin-bottom: 10px;
}
.rule_box {
  display: flex;
}
.rule_left {
  width: 38%;
}
.rule_right {
  width: 60%;
}
>>> .el-input__inner {
  width: 290px;
  height: 46px;
  background: #f9f9f9;
}
>>> .el-form-item {
  margin-top: 10px;
}
>>> .el-form-item__label {
  color: #333333;
  font-size: 16px;
  font-weight: 600;
}
>>> .el-checkbox-button {
  margin-right: 10px;
}
>>> .el-checkbox-button__inner {
  width: 90px;
  height: 46px;
  background: #f9f9f9;
  border-radius: 2px;
  border: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
>>> .el-checkbox-button.is-checked .el-checkbox-button__inner {
  background-color: #ffe6e5;
  color: #e53631;
  box-shadow: none;
}
>>> .el-checkbox-button__inner:hover {
  color: #e53631;
}
.content_box >>> .el-textarea__inner {
  width: 562px;
  height: 102px;
  background: #f9f9f9;
}
.btn {
  width: 320px;
  height: 50px;
  background: #e53631;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  line-height: 50px;
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 100px;
  cursor: pointer;
}
</style>